export default __webpack_public_path__ + "static/media/cancer-page-2.43b996a1.png";